import { ToggleLeft, ToggleRight } from "lucide-react";
import type { Subscription } from "../../lib/types";

interface Props {
  subscriptions: Subscription[];
  onToggle: (id: number, active: boolean) => void;
}

const fmt = (n: number) =>
  n.toLocaleString("es-MX", { maximumFractionDigits: 0 });

export function SubscriptionsTable({ subscriptions, onToggle }: Props) {
  const total = subscriptions.reduce((sum, s) => sum + s.amount, 0);

  return (
    <div className="card overflow-hidden">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between">
        <h3 className="text-sm font-medium text-gray-300">
          Suscripciones Activas
        </h3>
        <span className="text-xs text-gray-500">
          Total: ${fmt(total)}/mes = ${fmt(total * 12)}/ano
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[11px] text-gray-500 uppercase border-b border-border">
              <th className="px-4 py-2 text-left">Servicio</th>
              <th className="px-4 py-2 text-right">Monto</th>
              <th className="px-4 py-2 text-left">Categoria</th>
              <th className="px-4 py-2 text-left">Tarjeta</th>
              <th className="px-4 py-2 text-center">Estado</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {subscriptions.map((s) => (
              <tr key={s.id} className="hover:bg-surface-3 transition-colors">
                <td className="px-4 py-2.5 text-gray-200">{s.name}</td>
                <td className="px-4 py-2.5 text-right text-gray-200">
                  ${fmt(s.amount)}
                </td>
                <td className="px-4 py-2.5">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-surface-4 text-gray-400">
                    {s.category}
                  </span>
                </td>
                <td className="px-4 py-2.5">
                  <div className="flex items-center gap-1.5">
                    <div
                      className="w-2 h-2 rounded-full"
                      style={{ backgroundColor: s.card_color }}
                    />
                    <span className="text-gray-400 text-xs">
                      {s.card_name}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-2.5 text-center">
                  <button
                    onClick={() => onToggle(s.id, !s.active)}
                    className="btn-ghost p-0.5"
                    title={s.active ? "Desactivar" : "Activar"}
                  >
                    {s.active ? (
                      <ToggleRight className="w-5 h-5 text-emerald-400" />
                    ) : (
                      <ToggleLeft className="w-5 h-5 text-gray-500" />
                    )}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
